export const requestStatus = {
  REJECT_REQUEST: 'rejected',
  APPROVE_REQUEST: 'approved',
  PENDING_REQUEST: 'pending',
};

export enum requestTypes {
  migrate_zone = 'ADMIN.MIGRATE',
  onboard_user = 'ADMIN.ONBOARDING',
  revoke_zone = 'ADMIN.ZONE_REVOKE',
  sync_keyaccount = 'ADMIN.SYNC_KEY_ACCOUNT',
  add_zone = 'ADMIN.ADD_ZONE',
  add_keyaccount = 'ADMIN.KA_ACCESS',
  revoke_keyaccount = 'ADMIN.KA_REVOKE',
}
